// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BKyy","left":"styles_left__1_m_s"};